import IAmount from "@/module/main/dto/IAmount";
import FinancingParameterType from "@/module/main/dto/FinancingParameterTypeEnum";
import IFinancingParameter from "@/module/main/dto/IFinancingParameter";

export default class FinancingParameter implements IFinancingParameter
{
    constructor(
        public type: FinancingParameterType = FinancingParameterType.BASE,
        public amountWithoutVat: IAmount
    )
    {
    }
}
